module.exports = __webpack_public_path__ + "static/media/mysql.fcf95e72.png";